var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reply"},[_c('img',{staticClass:"face",attrs:{"src":`./images/imavatars/${_vm.avatar}.png`,"alt":_vm.avatar}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }